export const APP_VERSION: string = __APP_VERSION__;
